<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-75">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>{{ quoteIcon }}</md-icon>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="form-horizontal" action method="post">
            <div class="md-layout-item md-medium-size-100 md-size-40">
              <md-field>
                <label>Value (&#163;)</label>
                <md-input v-model="value" required></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-100 md-size-80">
              <md-field>
                <label>Decription</label>
                <md-textarea
                  v-model="quote.description"
                  md-autogrow
                  required
                ></md-textarea>
              </md-field>
            </div>
          </form>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button
            native-type="submit"
            @click.native.prevent="onSubmit"
            class="md-success md-sm"
            :disabled="hasSubmit"
            ><md-icon class="material-icons">check</md-icon>Submit</md-button
          >
          <md-button class="md-danger md-sm" @click="onCancel"
            ><md-icon class="material-icons">close</md-icon>Cancel</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-25"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      quoteIcon: "quote/icon",
      quote: "quote/quote"
    })
  },
  async created() {
    await this.getQuoteDetails();
  },
  data() {
    return {
      hasSubmit: false,
      value: ""
    };
  },
  methods: {
    async getQuoteDetails() {
      await this.$store.dispatch(
        "quote/getQuoteDetail",
        this.$route.params.quoteId
      );
    },
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("quote/reissueQuote", {
          form: this.generateForm()
        })
        .then(data => {
          this.$router.push({
            name: "Quote",
            params: { quoteId: data }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            let validationErrorDictionary = error.response.data.errors;
            for (var fieldName in validationErrorDictionary) {
              if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                errors.push("- " + validationErrorDictionary[fieldName]);
              }
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    },
    generateForm() {
      return {
        quoteId: this.$route.params.quoteId,
        description: this.quote ? this.quote.description : "",
        value: this.value ? parseFloat(this.value) : undefined
      };
    }
  }
};
</script>

<style></style>
